import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ORPCError } from '@orpc/client';
import { isAbortOrAbortCause } from '../utils/is-abort-or-abort-cause';
import { Auth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private snackBar = inject(MatSnackBar);
  private auth = inject(Auth);

  alert(message: string, duration = 5000, panelClass?: string | string[]) {
    this.snackBar.open(message, 'Fechar', {
      duration,
      panelClass,
      verticalPosition: 'top',
    });
  }

  /** @param customMessage mensagem exibida no lugar da mensagem padrão do erro (ex: contexto de uma chamada específica) */
  handleOrpcError(err: unknown, customMessage?: string) {
    console.log('Orpc Error:', err);
    console.log(
      'Orpc Error message:',
      err instanceof Error ? err.message : err,
    );

    if (isAbortOrAbortCause(err)) return;
    if (err instanceof ORPCError) {
      console.log(err.data);
      if (customMessage) {
        this.alert(customMessage, -1);
      } else if (err.data && err.data.issues) {
        this.alert(JSON.stringify(err.data.issues, null, 2), -1);
      } else {
        this.alert(typeof err === 'string' ? err : err.message, -1);
      }

      if (err.code === 'UNAUTHORIZED') {
        this.auth.signOut();
      }
      throw err;
    } else if (err instanceof Error) {
      this.alert(
        customMessage ??
          (typeof err === 'string'
            ? JSON.stringify(err)
            : JSON.stringify(err.message)),
        -1,
      );
      throw err;
    }
  }
}
